module.exports = __webpack_public_path__ + "img/horizontal_7_3_pp3_8003.7e76511c.png";